var map = {
  "./tr-TR.json": [
    "48383",
    "6128"
  ],
  "./fr-FR.json": [
    "61471",
    "7124"
  ],
  "./th-TH.json": [
    "49675",
    "9280"
  ],
  "./EN.json": [
    "5471"
  ],
  "./zh-CN.json": [
    "17792",
    "8521"
  ],
  "./ko-KR.json": [
    "42260",
    "8341"
  ],
  "./es-419.json": [
    "86235",
    "314"
  ],
  "./ms-MY.json": [
    "2889",
    "1026"
  ],
  "./vi-VN.json": [
    "11572",
    "8685"
  ],
  "./ar-SA.json": [
    "19878",
    "1851"
  ],
  "./es-ES.json": [
    "68599",
    "2483"
  ],
  "./pt-PT.json": [
    "18395",
    "4832"
  ],
  "./pt-BR.json": [
    "86847",
    "1136"
  ],
  "./it-IT.json": [
    "389",
    "4822"
  ],
  "./de-DE.json": [
    "89053",
    "4438"
  ],
  "./ja-JP.json": [
    "27690",
    "4683"
  ],
  "./id-ID.json": [
    "83589",
    "1110"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 41690;
module.exports = __rspack_async_context;
